import { useEffect } from "react";
import BackButton from "src/components/BackButton";
import CloseButton from "src/atoms/CloseButton";
import { useFrame } from "src/components/Frame/Context";

export default function NavigationButtons({
  onBack,
  onClose,
  mode,
  backButtonProps,
  closeButtonProps
}) {
  const frame = useFrame();

  function shouldUpdateFrame() {
    return mode === "fullScreen" && frame != null;
  }

  useEffect(() => {
    if (shouldUpdateFrame()) {
      frame.update({ onBack, backButtonProps });
    }

    return () => {
      if (shouldUpdateFrame()) {
        frame.update({ onBack: null, backButtonProps: null });
      }
    };
  }, []);

  useEffect(() => {
    if (shouldUpdateFrame()) {
      frame.update({ onBack, backButtonProps });
    }
  });

  return shouldUpdateFrame() ? null : (
    <>
      {onBack && <BackButton onClick={onBack} absolute />}
      {backButtonProps && <BackButton absolute {...backButtonProps} />}

      {onClose && mode === "modal" && (
        <CloseButton onClick={onClose} absolute />
      )}
      {closeButtonProps && mode === "modal" && (
        <CloseButton absolute {...closeButtonProps} />
      )}
    </>
  );
}
